// extracted by mini-css-extract-plugin
export default {"container":"DashboardHeader_container__yYqFk"};